export const initState = {
	step: 'conditions', // conditions, docs, selectDate, form, checkOtp, completed
	conditions: {
		content: '',
	},
	docs: {
		content: '',
	},
	selectDate: {
		date: '',
		turnId: '',

		selectedDate: '',
		selectedTime: '',

		$timesList: [],
		_timesList: 'init',

		reservableCount: 0,
	},
	form: {
		_form: 'init',
		personalInfo: {
			name: '',
			lastName: '',
			nationalNumber: '',
			birthPlace: '',
			birthDate: null,
			gender: null,
			nationality: '',
			address: '',
			postalCode: '',
			phone: '',
			cellphone: '',
		},
		transactionInfo: {
			currency: null,
			amount: '',
		},
	},
	checkOtp: {
		_checkOtp: 'init',
		code: '',
	},
};

export default initState;
